import React from 'react';
import volumeControllerStyle from './VolumeController.module.scss';

const { useEffect, useState } = React;

type VolumeControllerProps = {
    changeVolume: any,
    className?: any,
    currentTrack: any
}

export const VolumeController = ({ changeVolume, className = "", currentTrack }: VolumeControllerProps) => {
    const [volume, setVolume] = useState(.5);

    useEffect(() => {
        changeVolume(volume);
    }, [volume])

    useEffect(() => {
        changeVolume(volume);
    }, [currentTrack])

    const changeVol = (e: any) => {
        setVolume(e.target.value);
    }

    const setVolumeIcon = (volume: number) => {
        if (volume <= 0) return <i className="fas fa-volume-off"></i>;
        else if (volume < .5) return <i className="fas fa-volume-down"></i>;
        else return <i className="fas fa-volume-up"></i>;
    }

    const toggle = () => {
        if (volume <= 0) setVolume(1);
        else setVolume(0);
    }

    return (
        <div className={`${volumeControllerStyle.volume} ${className}`}>
            <input
                type="range"
                min={0}
                max={1}
                step={0.02}
                name="volumeSlider"
                value={volume}
                onChange={changeVol}
                className={volumeControllerStyle.volumeSlider} />
            <div
                onClick={toggle}
                className={volumeControllerStyle.volumeBlock}>
                {setVolumeIcon(volume)}
            </div>
        </div>
    )
}